/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentBannerCloseButtonHeight = "3.25rem";
export const componentBannerCloseButtonIconName = "Close";
export const componentBannerCloseButtonIconSize = "small";
export const componentBannerCloseButtonVariantErrorIconColor = "#fff";
export const componentBannerCloseButtonVariantInfoIconColor = "#000";
export const componentBannerCloseButtonVariantSuccessIconColor = "#fff";
export const componentBannerCloseButtonVariantWarningIconColor = "#000";
export const componentBannerCloseButtonWidth = "3rem";
export const componentBannerContainerAlignVertical = "flex-start";
export const componentBannerContainerVariantErrorBackgroundColor = "#de1c24";
export const componentBannerContainerVariantInfoBackgroundColor = "#e3e4e5";
export const componentBannerContainerVariantSuccessBackgroundColor = "#2a8703";
export const componentBannerContainerVariantWarningBackgroundColor = "#ffc220";
export const componentBannerLabelFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentBannerLabelFontSize = "0.875rem";
export const componentBannerLabelFontWeight = "400";
export const componentBannerLabelLineHeight = "1.25rem";
export const componentBannerLabelMaxWidth = "43.75rem";
export const componentBannerLabelTextAlign = "center";
export const componentBannerLabelVariantErrorTextColor = "#fff";
export const componentBannerLabelVariantInfoTextColor = "#000";
export const componentBannerLabelVariantSuccessTextColor = "#fff";
export const componentBannerLabelVariantWarningTextColor = "#000";
export const componentBannerLabelContainerAlignHorizontal = "center";
export const componentBannerLabelContainerPaddingBottom = "1rem";
export const componentBannerLabelContainerPaddingLeft = "1rem";
export const componentBannerLabelContainerPaddingRight = 0;
export const componentBannerLabelContainerPaddingTop = "1rem";